import React, { Component } from 'react';
import moment from 'moment';
import ChartHelper from '../Helper/ChartHelper';

export default class MetricsGoalItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        window.MetricsGoalItem = this;

        this.state = {
            expanded: false
        }

        this.toggleExpanded = this.toggleExpanded.bind(this);

        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToDisplay = this.convertToDisplay.bind(this);

        this.getShortLongitude = this.getShortLongitude.bind(this);
        this.calculateGoalFinalValue = this.calculateGoalFinalValue.bind(this);


        this.chartHelper = new ChartHelper();

        this.shortLongObj = this.getShortLongitude();
        this.longData = this.shortLongObj.longData;
        this.nowData = this.shortLongObj.nowData;
        this.shortDaySpan = this.shortLongObj.daySpan;
        this.goalFinalValue = this.calculateGoalFinalValue();
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    toggleExpanded() {

        this.props.expandGoal(this.props.identity);
        //this.setState({ expanded: !this.state.expanded });
    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToDisplay(type, number) {

        let endText = "";
        switch (type) {
            case 'MNY':
                endText += '$' + this.numberWithCommas(number);
                break;
            case 'INT':
                let newNum = parseFloat(number);
                if (newNum === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(0));
                }
                break;
            case 'PCT':
                let newNum1 = parseFloat(number);
                if (newNum1 === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(1)) + '%';
                }
                break;
            default:
                endText += this.numberWithCommas(number);
        }
        return endText;
    }

    getShortLongitude() {
        let identity = this.props.identity;
        let blastData = identity.blastData;

        blastData = _.sortBy(Object.values(identity.blastData.reduce((r, e) => {
            let key = e.name + "|" + e.dateIndex + "|" + e.goalContestReportKpi.reportKpiId;
            if (!r[key]) {
                r[key] = {
                    calEnd: e.calEnd,
                    calStart: e.calStart,
                    cyValue: e.cyValue,
                    date: e.date,
                    dateIndex: e.dateIndex,
                    goalContestReportKpi: e.goalContestReportKpi,
                    id: e.id,
                    locationId: e.locationId,
                    lyValue: e.lyValue,
                    name: e.name,
                    type: e.type,
                    userId: e.userId
                }
            } else {
                r[key].cyValue += e.cyValue;
                r[key].lyValue += e.lyValue;
            }
            return r;
        }, {})), 'dateIndex');

        let tempDateIndex = moment(new Date(this.props.selectedDate)).format('YYYYMMDD');
        let pastDateIndex = tempDateIndex;
        let futureDateIndex = tempDateIndex;
        let tempLong = [];
        let tempNowData = 0;
        for (var i = 0; i < blastData.length; i++) {
            if (blastData[i].dateIndex.toString() === tempDateIndex) {

                pastDateIndex = moment(new Date(blastData[i].calStart)).format('YYYYMMDD');
                futureDateIndex = moment(new Date(blastData[i].calEnd)).format('YYYYMMDD');
                break;
            }
        }
        for (var i = 0; i < blastData.length; i++) {
            if (blastData[i].dateIndex <= parseInt(tempDateIndex) && blastData[i].dateIndex >= parseInt(pastDateIndex)) {

                tempLong.push(blastData[i].cyValue);
                if (blastData[i].dateIndex === parseInt(tempDateIndex)) {
                    tempNowData = blastData[i].cyValue;
                }
            }
        }

        let timeDiff = moment(futureDateIndex).diff(moment(pastDateIndex), 'days') + 1;

        return { longData: tempLong, nowData: tempNowData, daySpan: timeDiff };
    }

    calculateGoalFinalValue() {
        if (this.props.identity.type === '#') {
            return this.props.identity.value;
        } else if (this.props.identity.type === '%') {

            let identity = this.props.identity;
            let blastData = identity.blastData;


            let tempDateIndex = moment(new Date(this.props.selectedDate)).format('YYYYMMDD');
            let targetDateIndex = tempDateIndex;
            for (var i = 0; i < blastData.length; i++) {

                if (blastData[i].dateIndex.toString() === tempDateIndex) {

                    targetDateIndex = moment(new Date(
                        identity.timeFrame === 'Day' ? blastData[i].calStart.substring(0, blastData[i].calStart.length - 1) : blastData[i].calEnd.substring(0, blastData[i].calEnd.length - 1)
                    )).format('YYYYMMDD');
                    break;
                }
            }

            let lastYear = 0;

            for (var i = 0; i < blastData.length; i++) {

                if ((blastData[i].dateIndex.toString() === targetDateIndex) &&
                    ((identity.locationId === null && identity.userId === null) ||
                        (identity.locationId != null && identity.userId === null &&
                            identity.locationId === blastData[i].locationId) ||
                        (identity.userId != null && identity.userId === blastData[i].userId))) {

                    lastYear = blastData[i].lyValue;
                    break;
                }
            }

            return this.props.identity.blastLastYearValue * (identity.useUnder ? 1 - (identity.value / 100) : 1 + (identity.value / 100));

        } else {
            return 0;
        }
    }

    render() {

        this.shortLongObj = this.getShortLongitude();
        this.longData = this.shortLongObj.longData;
        this.nowData = this.shortLongObj.nowData;
        this.shortDaySpan = this.shortLongObj.daySpan;
        this.goalFinalValue = this.calculateGoalFinalValue();

        let outerStyle = {
            position: 'relative',
            height: (this.props.expanded ? '16.85rem' : '5.5rem'),
            transition: 'height 0.25s ease-in-out 0s'
        }

        let toggleStyle = {
            transform: this.props.expanded ? "rotateX(180deg)" : "rotateX(0deg)"
        }


        let meatStyle = {

        }
        let fillbarStyle = {
            width: this.nowData / this.goalFinalValue > 1 ? '100%' : this.nowData / this.goalFinalValue * 100 + '%',
        }
        if (this.props.expanded) {
            meatStyle.top = '4.9rem'
            meatStyle.left = '0.6rem';
            meatStyle.width = 'calc(100% -  1.2rem)';
            meatStyle.height = '11.3rem';
            meatStyle.backgroundColor = 'rgba(255, 255, 255, 0)';

            fillbarStyle.width = '100%';
            fillbarStyle.height = '0rem';
        }

        let bottomMessage = (
            ((this.goalFinalValue - this.nowData).toFixed(2) <= 0 && !this.props.identity.useUnder) ||
                ((this.goalFinalValue - this.nowData).toFixed(2) >= 0 && this.props.identity.useUnder) ?
                "Congratulations! You reached your goal!"
                :
                "Only " + this.convertToDisplay(this.props.numType, (this.goalFinalValue - this.nowData).toFixed(2)) + ' until you reach your goal!'
        )


        return (
            <div className="metrics-central-regular-card-container" style={outerStyle} onClick={this.toggleExpanded}>
                <div className="metrics-goal-item-top-bar">
                    <div className="metrics-goal-item-icon-container">
                        <div className="metrics-goal-item-icon">
                            <svg className="metrics-goal-item-icon-svg" style={{ fill: '#ffffff' }} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.896 28.896">
                                <polygon points="17.698,0 14.448,4.334 11.198,0 4.948,0 14.448,12.667 23.948,0 		" />
                                <polygon points="17.085,18.009 14.448,12.667 11.811,18.009 5.915,18.865 10.182,23.025 9.175,28.896 14.448,26.125 19.722,28.896 18.714,23.025 22.98,18.865 		" />
                            </svg>
                        </div>
                    </div>
                    <div className="metrics-goal-item-name-container">
                        <div className="metrics-goal-item-name">
                            {this.props.identity.name}
                        </div>
                        <div className={"metrics-goal-item-timeframe"}>
                            {this.props.identity.timeFrame + " to Date"}
                        </div>
                    </div>
                    <div className="metrics-goal-item-goal-number-container">
                        <div className="metrics-goal-item-goal-number-top">
                            {this.convertToDisplay(this.props.numType, this.nowData.toFixed(2)) + " /"}
                        </div>
                        <div className="metrics-goal-item-goal-number-bottom">
                            {this.convertToDisplay(this.props.numType, this.goalFinalValue.toFixed(2))}
                        </div>
                    </div>
                    <div className="material-icons metrics-goal-item-toggle-icon" style={toggleStyle}>
                        keyboard_arrow_down
                    </div>
                </div>
                <div className="metrics-goal-item-meat-container" style={meatStyle}>
                    <div className="metrics-goal-item-fill-bar" style={fillbarStyle}></div>
                    <div className="metrics-goal-item-chart-container">
                        {this.chartHelper.generateLineFillChart(this.longData, this.shortDaySpan, this.goalFinalValue)}
                    </div>
                    <div className="metrics-goal-item-bottom-message">{bottomMessage}</div>
                </div>
            </div>
        );
    }
}